import React from 'react';
import { MatchCard } from './MatchCard';
interface MatchListProps {
  role: 'brand' | 'organizer';
  onViewProfile?: (profile: any) => void;
}
// Mock match data
const mockMatches = [{
  id: '1',
  name: 'Tech Summit 2024',
  tagline: 'Where innovation meets opportunity',
  image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=100&h=100&fit=crop',
  matchPercentage: 94,
  reasons: ['Audience age range matches your target (25-45)', 'Strong tech & innovation focus aligns with your brand', 'National reach matches your geographic goals'],
  explanation: 'This event attracts exactly the tech-savvy professionals you want to reach, with a proven track record of successful brand activations.',
  type: 'organizer' as const,
  profile: {
    name: 'Tech Summit 2024',
    tagline: 'Where innovation meets opportunity',
    description: 'The premier technology conference bringing together industry leaders, innovators, and visionaries.',
    mission: 'To accelerate innovation by connecting the brightest minds in technology.',
    interests: ['Tech', 'Innovation', 'Business', 'Sustainability'],
    values: ['Innovation', 'Diversity', 'Education'],
    audienceSize: 5000,
    ageMin: 25,
    ageMax: 45,
    geoReach: 'National',
    primaryGoal: 'Knowledge Sharing'
  }
}, {
  id: '2',
  name: 'Green Festival',
  tagline: 'Celebrating sustainable living',
  image: 'https://images.unsplash.com/photo-1464207687429-7505649dae38?w=100&h=100&fit=crop',
  matchPercentage: 87,
  reasons: ['Sustainability values perfectly aligned', 'Engaged, eco-conscious audience', 'Great sampling and activation opportunities'],
  explanation: 'Perfect for brands committed to sustainability. Their audience actively seeks eco-friendly products and experiences.',
  type: 'organizer' as const,
  profile: {
    name: 'Green Festival',
    tagline: 'Celebrating sustainable living',
    description: 'An annual celebration of sustainable living, eco-innovation, and community connection.',
    mission: 'To inspire and empower communities to live more sustainably.',
    interests: ['Sustainability', 'Lifestyle', 'Food', 'Art'],
    values: ['Sustainability', 'Community', 'Health'],
    audienceSize: 15000,
    ageMin: 22,
    ageMax: 55,
    geoReach: 'Regional',
    primaryGoal: 'Community Building'
  }
}, {
  id: '3',
  name: 'Urban Music Fest',
  tagline: 'The sound of the city',
  image: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=100&h=100&fit=crop',
  matchPercentage: 82,
  reasons: ['Young, engaged demographic', 'High social media reach and engagement', 'Premium brand activation spaces available'],
  explanation: 'High-energy event with massive social reach. Great for brands targeting Gen Z and millennials.',
  type: 'organizer' as const,
  profile: {
    name: 'Urban Music Fest',
    tagline: 'The sound of the city',
    description: 'A three-day music festival featuring the hottest artists in hip-hop, R&B, and electronic music.',
    mission: 'To celebrate urban culture and bring communities together through music.',
    interests: ['Music', 'Fashion', 'Lifestyle', 'Entertainment'],
    values: ['Diversity', 'Entertainment', 'Community'],
    audienceSize: 30000,
    ageMin: 18,
    ageMax: 35,
    geoReach: 'National',
    primaryGoal: 'Brand Awareness'
  }
}];
export function MatchList({
  role,
  onViewProfile
}: MatchListProps) {
  const accentText = role === 'brand' ? 'text-cyan-400' : 'text-purple-400';
  return <div data-id="element-224">
      <div className="flex items-center justify-between mb-6" data-id="element-225">
        <div data-id="element-226">
          <h2 className="text-2xl font-bold text-white" data-id="element-227">Your Matches</h2>
          <p className="text-slate-400" data-id="element-228">
            AI-powered recommendations based on your profile
          </p>
        </div>
        <span className={`text-sm font-medium ${accentText}`} data-id="element-229">
          {mockMatches.length} matches found
        </span>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-230">
        {mockMatches.map(match => <MatchCard key={match.id} name={match.name} tagline={match.tagline} image={match.image} matchPercentage={match.matchPercentage} reasons={match.reasons} explanation={match.explanation} type={match.type} onViewProfile={() => onViewProfile?.(match.profile)} onConnect={() => console.log('Connect with', match.name)} data-id="element-231" />)}
      </div>
    </div>;
}